import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "メッセージ配信", -1)

import { onBeforeMount, ref, computed, reactive } from "vue";
import { set, get } from "@vueuse/core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import FormEdit from "./common/form.vue";
import { MessageService } from "@/clinic/services";
import Trash from "@/clinic/components/trash.vue";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { useToast } from "primevue/usetoast";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const toast = useToast();

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});
const onTrash = async () => {
  await MessageService.trashMessage(
    get(idUrl),
    get(channelId),
    () => notifySuccessMsg(toast, "成功"),
    () => notityErrorMsg(toast, "エラー")
  );
};

const channelId = ref<any>(0);
const isLoading = ref(false);

const model = reactive<any>({});

onBeforeMount(async () => {
  set(isLoading, true);
  set(channelId, await store.dispatch("authClient/getChannelIdCookie"));
  const { data } = await MessageService.detail(get(idUrl), get(channelId));
  Object.assign(model, get(data));
  set(isLoading, false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Trash, {
      id: _unref(get)(_unref(idUrl)),
      onTrash: onTrash
    }, null, 8, ["id"]),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(FormEdit, {
          key: 0,
          channelId: channelId.value,
          model: model,
          hasEdit: true
        }, null, 8, ["channelId", "model"]))
      : _createCommentVNode("", true)
  ]))
}
}

})